import { useFormikContext } from "formik";
import {
  DesignsDraftApi,
  EfsMelcoModelsDesign,
  useAPIAction,
} from "melco-shared-logic";
import { QueryObserverResult, useQueryClient } from "react-query";
import { designToInitialValues } from "../../../components/libraries/designs/DesignDetailForm";
import { isPrintDesignFileName } from "../../../helper/designHelper";
import { NOTIFICATIONS_CACHE_KEY } from "../../notifications/useNotifications";

export const useDesignUpdate = (
  designId: string,
  refetch: () => Promise<QueryObserverResult<EfsMelcoModelsDesign, unknown>>
) => {
  const { resetForm } = useFormikContext();
  const queryClient = useQueryClient();

  const [updateDesign, isLoading] = useAPIAction(
    DesignsDraftApi,
    async (api, file: Blob) => {
      const isPrintFile = isPrintDesignFileName(file.name);

      const data = isPrintFile
        ? await api.userDesignsPrintQueueUpdateFileDraft({
          id: designId,
          file,
        })
        : await api.userDesignsUpdateDraftFile({
          id: designId,
          file,
        });

      return {
        successMessages: [
          {
            message: isPrintFile ? "print" : "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "designs.actions.update",
      onSuccess: async () => {
        const refetchResult = await refetch();

        resetForm({
          values: refetchResult.data
            ? designToInitialValues(refetchResult.data)
            : {},
        });

        queryClient.invalidateQueries(NOTIFICATIONS_CACHE_KEY);
      },
    }
  );

  return {
    updateDesign,
    isLoading,
  } as const;
};
